import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { AnalyticsData } from '../login-authentication-screen/models/login-credentials.interface';
import { CheckYourEmail } from './models/check-email.interface';

@Component({
  selector: 'idp-check-email',
  templateUrl: './check-email.component.html',
  styleUrls: ['./check-email.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CheckEmailComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() pageData!: CheckYourEmail | undefined | null;
  @Input() callBackFunction!: () => void;
  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() closeOverlayMessage: EventEmitter<boolean> = new EventEmitter();
  @Output() redirectTrackingClick: EventEmitter<AnalyticsData> =
    new EventEmitter<AnalyticsData>();

  pageLoadStartTime: number;
  constructor(private elemRef: ElementRef) {
    this.pageLoadStartTime = performance.now();
  }

  ngOnInit() {
    if (this.pageLoadStartTime) {
      this.redirectTrackingClick.emit({
        action: 'Check Your Email',
        eventDetails: 'pageLoad',
        startTime: this.pageLoadStartTime
      });
    }
  }

  submit() {
    this.redirectTrackingClick.emit({ action: this.pageData?.viewName });
    this.nextDisplayView.emit(this.pageData?.nextDisplayView?.nextViewName);
  }

  viewSqa() {
    this.nextDisplayView.emit(this.pageData?.nextDisplayView?.nextViewName_sqa);
  }

  ngAfterViewInit(): void {
    if (this.pageData?.skipSqaContent) {
      this.elemRef.nativeElement
        .querySelector('#check_email_section > .sqa-content')
        ?.remove();
    } else {
      this.elemRef.nativeElement
        .querySelector('.click-here')
        ?.addEventListener('click', this.viewSqa.bind(this));
    }
  }

  onClosePopUp(): void {
    this.closeOverlayMessage.emit(false);
  }

  ngOnDestroy(): void {
    this.elemRef.nativeElement
      .querySelector('.click-here')
      ?.removeEventListener('click', this.viewSqa, true);
    this.callBackFunction();
  }
}
